import React from "react"
import { graphql } from "gatsby"

import SEO from "../components/seo"
import Layout from "../components/layout"
import GeniusSection from "../components/geniusSection"
import RichText from "../components/richText"
import ImageTextSection from "../components/imageTextSection"
import Section from "../components/section"
import VideoEmbed from "../components/videoEmbed"
import Slider from "../components/slider"
import CTA from "../components/cta"

import styles from "./genius.module.scss"

export const query = graphql`
  query {
    sanityGenius {
      _rawImage(resolveReferences: { maxDepth: 10 })
      _rawImageText(resolveReferences: { maxDepth: 10 })
      _rawImageText2(resolveReferences: { maxDepth: 10 })
      slider: _rawSlider(resolveReferences: { maxDepth: 10 })
      datePublished: _createdAt
      dateModified: _updatedAt
      _rawRichTextIntro
      _rawRichTextQuote
      _rawCta
      _rawCtaSection
      _rawSeo
      _rawVideo
      _rawSlider
      title
      videoTitle
      seo {
        metaTitle
        canonical
        description
        noIndex
        openGraphImage {
          asset {
            url
          }
        }
      }
    }
  }
`

const Genius = ({ data }) => {
  const page = data.sanityGenius

  const video = page._rawVideo && {
    title: page.videoTitle,
    embedUrl: page._rawVideo.url,
  }

  return (
    <Layout>
      <SEO
        title={page.title}
        dateModified={page.dateModified}
        datePublished={page.datePublished}
        video={video}
        {...page.seo}
      />
      <GeniusSection image={page._rawImage} cta={page._rawCta} />
      <Section bg="light" theme="course-genius">
        <div className="grid">
          <div className={`gridItem large-10 large-offset-1 ${styles.center}`}>
            <h1>{page.title}</h1>
            <hr className={styles.thematicBreak} />
            <RichText blocks={page._rawRichTextIntro} />
          </div>
        </div>
      </Section>
      <Section bg="dark" theme="course-genius">
        <div className="grid">
          <div className="gridItem large-10 large-offset-1">
            <RichText blocks={page._rawRichTextQuote} />
          </div>
        </div>
      </Section>
      <Section bg="light" theme="course-genius">
        <div className="grid">
          <div className="gridItem large-10 large-offset-1">
            <ImageTextSection
              text={page._rawImageText?.text}
              images={page._rawImageText?.images}
              reverseLayout={page._rawImageText2?.reverseLayout}
              alt
            />
          </div>
        </div>
      </Section>
      <Section bg="light" theme="course-genius">
        <div className="grid">
          <div className="gridItem large-8 large-offset-2">
            <h2 className={styles.center}>{page.videoTitle}</h2>
            <hr className={styles.thematicBreak} />
            <VideoEmbed url={page._rawVideo?.url} />
          </div>
        </div>
      </Section>
      <Section bg="light" theme="course-genius">
        <div className={styles.geniusSlider}>
          <Slider images={page.slider} />
        </div>
      </Section>
      <Section bg="light" theme="course-genius">
        <div className="grid">
          <div className="gridItem large-10 large-offset-1">
            <ImageTextSection
              text={page._rawImageText2?.text}
              images={page._rawImageText2?.images}
              reverseLayout={page._rawImageText2?.reverseLayout}
              alt
            />
          </div>
        </div>
      </Section>
      <CTA {...page._rawCtaSection} />
    </Layout>
  )
}

export default Genius
